import { gql } from "lib/apolloClient";
import { fragments } from "./RoutineTemplatesFragments";

export const createRoutineTemplateMutation = gql`
  mutation createPostTemplate($input: CreatePostTemplateInput) {
    documentation {
      createPostTemplate(input: $input) {
        warning
        isSuccess
        template {
          id
          type
          title
          presetTemplateId
        }
      }
    }
  }
`;

export const updatePostTemplateMutation = gql`
  mutation updatePostTemplate($input: UpdatePostTemplateInput) {
    documentation {
      updatePostTemplate(input: $input) {
        isSuccess
        warning
      }
    }
  }
`;

export const deletePostTemplateMutation = gql`
  mutation deletePostTemplate($input: DeletePostTemplateInput!) {
    documentation {
      deletePostTemplate(input: $input) {
        warning
        isSuccess
        error {
          code
        }
      }
    }
  }
`;

export const importPostTemplateData = gql`
  mutation importPostTemplate($input: ImportPostTemplateInput!) {
    documentation {
      importPostTemplate(input: $input) {
        isSuccess
        isNewTemplateRequired
        warning
        oldTemplate {
          ...postTemplate
        }
        newTemplate {
          ...postTemplate
        }
      }
    }
  }
  ${fragments.templateCourseItem}
  ${fragments.postTemplate}
`;
